import { createGlobalStyle } from "styled-components";
import ManropeFont from "../assets/fonts/Manrope-VariableFont_wght.ttf";

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Manrope';
    src: url(${ManropeFont}) format('truetype');
    font-display: swap;
  }

  /* Thin custom scrollbars globally */
  *::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  *::-webkit-scrollbar-track {
    background: transparent;
  }
  *::-webkit-scrollbar-thumb {
    background: #CCD2DD;
    border-radius: 3px;
  }
  *::-webkit-scrollbar-thumb:hover {
    background: #B0B8C6;
  }
`;

export default GlobalStyles;
